const createStreamTrackingEventHandlers = ({ onStreamsUpdated }) => {
  let streams = [];

  const onStreamCreated = event => {
    if (!streams.some(stream => stream.id === event.stream.id)) {
      streams = [...streams, event.stream];
      onStreamsUpdated(streams);
    }
  };

  const onStreamDestroyed = event => {
    streams = streams.filter(stream => stream.id !== event.stream.id);
    onStreamsUpdated(streams);
  };

  const eventHandlers = {
    streamCreated: onStreamCreated,
    streamDestroyed: onStreamDestroyed,
  };

  return eventHandlers;
};

export default createStreamTrackingEventHandlers;
